import React from 'react';
import styled from 'styled-components';

export const Buttons: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => (
  <s.div className={className}>{children}</s.div>
);

const s = {
  div: styled.div`
    display: flex;
    margin: 20px -2px 0px;
  `
};
